import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';

import { CMSGameCover } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import { createCMSQuery, getCMSImageFieldsUrl } from '@/modules/cms';
import { GameCovers } from '@/store/commonStore/types';

const GAME_COVERS_LIMIT = 3000;

export const useCMSGameCovers = () => {
  const query = useMemo(() => {
    return createCMSQuery({
      populate: {
        ...getCMSImageFieldsUrl('cover'),
      },
      pagination: {
        pageSize: GAME_COVERS_LIMIT,
      },
    });
  }, []);

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<CMSGameCover[]>(`/game-covers?${query}`, fetcherCMS);

  const covers = useMemo(
    () =>
      data.reduce((acc, { gameId, cover, gradientColor }) => {
        acc[gameId] = { cover, gradientColor };
        return acc;
      }, {} as GameCovers),
    [data]
  );

  return {
    covers,
    error,
    isLoading,
  };
};
